import {getAppOrigin} from '@salesforce/pwa-kit-react-sdk/utils/url'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const subscribeNewsletterHelper = async (personalInfo, siteId, token, customTag, locale) => {
    const {
        app: {commerceAPI}
    } = getConfig()
    const {
        parameters: {organizationId}
    } = commerceAPI
    const appOrigin = getAppOrigin()

    const urlParams = new URLSearchParams()
    urlParams.append('siteId', siteId)
    urlParams.append('locale', locale)

    return fetch(
        `${appOrigin}${
            commerceAPI.proxyPath
        }/custom/customer/v1/organizations/${organizationId}/subscribe-to-newsletter?${urlParams.toString()}`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: personalInfo?.email,
                firstName: personalInfo?.firstName,
                lastName: personalInfo?.lastName,
                membershipMenValue: personalInfo?.membershipPreferences?.men,
                membershipWomenValue: personalInfo?.membershipPreferences?.women,
                tag: customTag ? customTag : 'checkout_newsletter'
            })
        }
    )
}

export default subscribeNewsletterHelper
